export default __webpack_public_path__ + "images/64c509989d91d6ab05cafb6725b1a1c0-YGP_citybrowseheader_LDN_791x488px@2x.webp";